export type PlanType = 'free' | 'starter' | 'pro' | 'enterprise';

export interface PlanLimits {
  maxUsers: number;
  maxProjects: number;
  maxClients: number;
  fileUploads: boolean;
  analytics: boolean;
  roleManagement: boolean;
}

export const PLAN_LIMITS: Record<PlanType, PlanLimits> = {
  free: {
    maxUsers: 2,
    maxProjects: 1,
    maxClients: 1,
    fileUploads: false,
    analytics: false,
    roleManagement: false,
  },
  starter: {
    maxUsers: Infinity,
    maxProjects: Infinity,
    maxClients: Infinity,
    fileUploads: true,
    analytics: false,
    roleManagement: false,
  },
  pro: {
    maxUsers: Infinity,
    maxProjects: Infinity,
    maxClients: Infinity,
    fileUploads: true,
    analytics: true,
    roleManagement: true,
  },
  enterprise: {
    maxUsers: Infinity,
    maxProjects: Infinity,
    maxClients: Infinity,
    fileUploads: true,
    analytics: true,
    roleManagement: true,
  },
};

export interface OrganizationInfo {
  _id: string;
  name: string;
  slug: string;
  plan: PlanType;
  trialEndsAt?: string;
}

export function getEffectivePlan(plan: PlanType, trialEndsAt?: string | null): PlanType {
  if (trialEndsAt && new Date(trialEndsAt) > new Date()) {
    return 'pro';
  }
  return plan;
}

export function getPlanLimits(plan: PlanType, trialEndsAt?: string | null): PlanLimits {
  return PLAN_LIMITS[getEffectivePlan(plan, trialEndsAt)];
}

export const PLAN_PRICING = {
  free: { price: 0, label: 'Free' },
  starter: { price: 12, label: 'Starter' },
  pro: { price: 18, label: 'Pro' },
  enterprise: { price: null, label: 'Enterprise' },
};
